import React from 'react';

interface CenteredLayoutProps {
  children: React.ReactNode;
  sectionId?: string;
  className?: string;
}

const CenteredLayout: React.FC<CenteredLayoutProps> = ({
  children,
  sectionId,
  className = ''
}) => {
  return (
    <section id={sectionId} className={`bg-gray-100 py-8 px-4 ${className}`}>
      <div className="container mx-auto">
        <div className="max-w-md mx-auto">
          {children}
        </div>
      </div>
    </section>
  );
};

export default CenteredLayout;
